// src/utils/debugDocumentDelivery.js
// Debug utility to check document delivery

function debugDocumentDelivery() {
    console.log('=== Document Delivery Debug ===');

    // Get current user
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    console.log('Current User:', {
        id: currentUser.id,
        email: currentUser.email,
        name: currentUser.name
    });

    // Check all document storage locations
    console.log('\n=== Document Storage Locations ===');

    // Generated documents
    const generated = JSON.parse(localStorage.getItem('generatedDocuments') || '[]');
    console.log(`Generated Documents (${generated.length}):`, generated.map(d => ({
        id: d.id,
        name: d.templateName,
        sentTo: d.sentTo,
        status: d.status
    })));

    // Employee-specific documents
    const employeeDocs = JSON.parse(localStorage.getItem(`employeeDocuments_${currentUser.id}`) || '[]');
    console.log(`\nEmployee Documents for ${currentUser.id} (${employeeDocs.length}):`, employeeDocs);

    const employeeCompanyDocs = JSON.parse(localStorage.getItem(`employeeCompanyDocuments_${currentUser.id}`) || '[]');
    console.log(`\nEmployee Company Documents for ${currentUser.id} (${employeeCompanyDocs.length}):`, employeeCompanyDocs);

    // Universal document pools
    const sharedPool = JSON.parse(localStorage.getItem('sharedDocumentPool') || '[]');
    console.log(`\nShared Document Pool (${sharedPool.length}):`, sharedPool);

    const allCompanyDocs = JSON.parse(localStorage.getItem('allCompanyDocuments') || '[]');
    const companyDocsForUser = allCompanyDocs.filter(d => d.sentTo === currentUser.id);
    console.log(`\nAll Company Documents for ${currentUser.id} (${companyDocsForUser.length}):`, companyDocsForUser);

    // Check for any documents sent to this user
    console.log('\n=== Documents Sent to This User ===');
    const allLocations = [
        ...JSON.parse(localStorage.getItem('generatedDocuments') || '[]'),
        ...JSON.parse(localStorage.getItem('sharedDocumentPool') || '[]'),
        ...JSON.parse(localStorage.getItem('universalCompanyDocuments') || '[]'),
        ...JSON.parse(localStorage.getItem('allCompanyDocuments') || '[]')
    ];

    const sentToUser = allLocations.filter(d => d.sentTo === currentUser.id);
    console.log(`Found ${sentToUser.length} documents sent to this user:`, sentToUser.map(d => ({
        id: d.id,
        name: d.templateName,
        sentAt: d.sentAt,
        type: d.type
    })));

    // Check for documents sent by email match (in case ID mismatch)
    const sentByEmail = allLocations.filter(d => d.sentToEmail === currentUser.email);
    if (sentByEmail.length > 0) {
        console.log(`\n⚠️ Found ${sentByEmail.length} documents sent by EMAIL (possible ID mismatch):`, sentByEmail);
    }

    console.log('\n=== Summary ===');
    console.log(`Total generated documents: ${generated.length}`);
    console.log(`Documents in employeeCompanyDocuments: ${employeeCompanyDocs.length}`);
    console.log(`Documents in allCompanyDocuments for user: ${companyDocsForUser.length}`);
    console.log(`Documents sent by ID match: ${sentToUser.length}`);
    console.log(`Documents sent by email match: ${sentByEmail.length}`);
}

// Make it globally available
window.debugDocumentDelivery = debugDocumentDelivery;
console.log('Debug utility loaded. Run debugDocumentDelivery() in console to check document delivery.');